module.exports = __webpack_public_path__ + "media/images/flags/16/Ethiopia-d6b34ec1045ec75ef669a1c4f454edea.png";